import { call, put, takeEvery } from 'redux-saga/effects';
import { gcApi } from 'config/axios';

import {
    CREATE_EXPORT_REPORT,
    CREATE_EXPORT_REPORT_FAIL,
    CREATE_EXPORT_REPORT_SUCCESS,
    CHECK_EXPORT_REPORT_STATUS,
    CHECK_EXPORT_REPORT_STATUS_FAIL,
    CHECK_EXPORT_REPORT_STATUS_SUCCESS
} from '../actions/ActionTypes';

// Workers
export function* postExportReport(action) {
    const { reportCategory, fromDate, toDate, locale, dateFormat } = action;

    try {
        const response = yield call(
            gcApi.post,
            `/reportexport-service/export/init/${reportCategory}/${fromDate}/${toDate}?locale=${locale}`,
            {
                reportSubCategory: 'string',
                reportFormat: 'PDF',
                contentToSkip: ['string'],
                requestedDateFormatKey: dateFormat
            }
        );

        yield put({
            type: CREATE_EXPORT_REPORT_SUCCESS,
            exportReport: response.data
        });
    } catch (e) {
        yield put({
            type: CREATE_EXPORT_REPORT_FAIL,
            exportReport: null
        });
    }
}

export function* checkExportReportStatus(action) {
    const { reportId } = action;

    try {
        const response = yield call(gcApi.get, `/reportexport-service/export/reportStatus/${reportId}`);

        yield put({
            type: CHECK_EXPORT_REPORT_STATUS_SUCCESS,
            reportStatus: response.data
        });
    } catch (e) {
        yield put({
            type: CHECK_EXPORT_REPORT_STATUS_FAIL,
            reportStatus: null
        });
    }
}

// Watchers
export const reportExportSagas = [
    takeEvery(CREATE_EXPORT_REPORT, postExportReport),
    takeEvery(CHECK_EXPORT_REPORT_STATUS, checkExportReportStatus)
];
